import api from '../lib/api';

export const FETCH_REPAIR_TICKETS = 'FETCH_REPAIR_TICKETS';
export const REPAIR_TICKETS_LOADING = 'REPAIR_TICKETS_LOADING';

export const FETCH_VEHICLE_CONSUMED_PARTS = 'FETCH_VEHICLE_CONSUMED_PARTS';

function fetchRepairTickets(query) {
  return (dispatch) => {
    dispatch({ type: REPAIR_TICKETS_LOADING, payload: true });

    return api.getRepairTickets(query)
      .then((data) => {
        dispatch({ type: FETCH_REPAIR_TICKETS, payload: data });
      })
      .then(() => {
        dispatch({ type: REPAIR_TICKETS_LOADING, payload: false });
      })
      .catch(() => {
        dispatch({ type: REPAIR_TICKETS_LOADING, payload: false });
      });
  };
}

export default {
  fetchRepairTickets,
  createRepairTicket(repairTicket) {
    return () => api.createRepairTicket(repairTicket);
  },
  updateRepairTicket(repairTicket, repairTicketId) {
    return () => api.updateRepairTicket(repairTicket, repairTicketId);
  },
  createTicketsForCases(caseData, marketId) {
    return () => api.createTicketsForCases(caseData, marketId);
  },
};
